import { getFunctions, httpsCallable } from "firebase/functions";
import app from "../firebase/config";

// Asks the server to give or remove the "staff" mark for one login,
// based on that person's saved role and status. Built on first use.
let _fn = null;
export async function syncStaffMark(uid) {
  if (!_fn) {
    _fn = httpsCallable(getFunctions(app, "asia-south1"), "syncStaffMark");
  }
  const res = await _fn({ uid });
  return res.data;
}
